<template>
<div class="footer_warp">
    <div class="logo_box">
        <img class="img1" :src="require('@/common/images/gujingimgs/logo2.png')" alt="">
        <div class="line_div"></div>
        <img class="img2" src="~common/images/gujing/logo_txt.png" alt="logo">
    </div>
    <div class="info_box">
        <div class="left_info_div">
            <p>深圳市资鲸科技有限公司</p>
            <div><img src="~common/images/gujing/phone.png" alt="phone">咨询热线：0755-86393135</div>
            <div><img src="~common/images/gujing/phone.png" alt="phone">顾问手机：13556826075</div>
        </div>
        <img class="qr_img" v-lazy="qr_img" alt="logo">
    </div>
    <!-- <p class="internet_text">&copy; 2017-2020 深圳市资鲸科技有限公司 粤 ICP 备 17145857号-1 </p> -->
    <p class="internet_text">© 2017-2022 深圳市资鲸科技有限公司 粤 ICP 备 17145857号-1 </p>
</div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
export default {
    name: 'Footer',
    data() {
        return {
           qr_img: 'http://img.capwhale.com/gj_dyh.jpg'
        }
    },
    mounted() {},
    methods: {
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'user'
        ])
    },
    components: {}
}
</script>

<style lang="scss" type="text/scss">
.footer_warp {
    font-family:PingFangSC-Regular,PingFang SC;
    background-color: #004A99;
    height: 4.08rem;
    padding: 0.48rem 0.32rem;
    box-sizing: border-box;
    color: #FFF;
    .logo_box {
        height: 0.4rem;
        display: flex;
        align-items: center;
        .img1 {
            width: 1.18rem;
            height: 0.4rem;
        }
        .line_div {
            width: 0.01rem;
            height: 0.26rem;
            background-color: #fff;
            margin: 0 0.2rem;
        }
        .img2 {
            height: 0.3rem;
        }
    }
    .info_box {
        margin-top: 0.4rem;
        display: flex;
        justify-content: space-between;
        .left_info_div {
            &>p {
                line-height: 0.34rem;
                font-size: 0.24rem;
            }
            &>div {
                line-height: 0.4rem;
                font-size: 0.28rem;
                display: flex;
                align-items: center;
                margin-top: 0.2rem;
                &>img {
                    width: 0.28rem;
                    height: 0.28rem;
                    margin-right: 0.2rem;
                }
            }
        }
        .qr_img {
            width: 1.5rem;
            height: 1.5rem;
        }
    }
    .internet_text {
        margin-top: 0.4rem;
        font-size: 0.2rem;
        line-height: 0.3rem;
    }
}
</style>